import { VIRTUAL_PAGES } from "./config";

function sendEvent(event, id) {
  if (!window?.rybbit) return null;
  const description = `${VIRTUAL_PAGES[event].virtualTitle}${id}`;
  params = id
    .split("/") // разбиваем по /
    .filter(Boolean) // убираем пустые элементы (из-за первого /)
    .reduce((acc, value, index) => {
      acc[`param_${index + 1}`] = value;
      return acc;
    }, {});
  window.rybbit.event(event, { id: id, description: description, ...params });
}

export { sendEvent };
